import appConst from "./appConst.json";

/**
 * Maps route pathnames to Braze-friendly screen names for screen_viewed events.
 * This centralized mapping allows marketing to trigger In-App Messages on specific screens.
 */
const brazeScreenNameMap = {
  [appConst.FIRST_PAGE]: "marketing", // /marketing
  [appConst.SECOND_PAGE]: "basket", // /basketItems
  [appConst.FIFTH_PAGE]: "shipping", // /shipping
  [appConst.SIXTH_PAGE]: "sub_shipping", // /subShipping
  [appConst.SEVENTH_PAGE]: "personal_details", // /personalDetails
  [appConst.EIGHTH_PAGE]: "summary", // /summary
  [appConst.NINTH_PAGE]: "payment", // /creditGuard
  [appConst.TENTH_PAGE]: "payment_error", // /paymentError
  [appConst.ELEVNTH_PAGE]: "success", // /success
  [appConst.TWELTH_PAGE]: "error", // /error
  [appConst.THIRTEEN_PAGE]: "empty_basket", // /empty_basket
};

/**
 * Get the screen name for a given pathname.
 * @param {string} pathname - The current route pathname (e.g., "/shipping")
 * @returns {string|null} - The friendly screen name or null if not found
 */
export const getScreenName = (pathname) => {
  return brazeScreenNameMap[pathname] || null;
};

export default brazeScreenNameMap;
